const initialStatus = {
  loading: false,
  success: false,
  error: false,
  data: null,
  message: null,
  expanded: {},
}

const initialState = {
  expanded: {},
  keyword: {},
  tabOpen: {},
  content: [],
  activeSkillId: null,
  cached: {
    global: [],
  },
}

const faqReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'RESET_FAQ_OBJ':
      return initialState
    case 'RESET_FAQ_STATUS':
      return {
        ...state,
        status: {
          ...state.status,
          [action.payload]: initialStatus,
        },
      }
    case 'FAQ_ERROR':
      return {
        ...state,
        status: {
          ...state?.status,
          [action?.payload?.action]: {
            ...initialStatus,
            error: true,
            message: action?.payload?.message,
          },
        },
      }
    case 'GET_FAQ': {
      return {
        ...state,
        status: {
          get_faq: {
            ...initialStatus,
            loading: action?.payload?.skillId
              ? true
              : state?.status?.get_faq?.loading,
          },
          get_faq_by_skill: {
            ...initialStatus,
            loading: action?.payload?.skillId
              ? state?.status?.get_faq_by_skill?.loading
              : true,
          },
        },
      }
    }
    case 'SET_ACTIVE_SKILL_ID_FAQ': {
      const skillId = action?.payload?.skillId
        ? action?.payload?.skillId
        : state.activeSkillId
      const content = state?.cached?.global?.length
        ? [...state?.cached?.global]
        : []

      if (skillId && state?.cached?.[skillId]?.length) {
        content.push(...state?.cached?.[skillId])
      }

      return {
        ...state,
        activeSkillId: skillId,
        content,
      }
    }

    case 'SET_FAQ': {
      return {
        ...state,
        content: [...state.cached.global, ...action?.payload?.data],
        cached: {
          ...state?.cached,
          global: action?.payload.skillId
            ? state?.cached?.global
            : action?.payload?.data,
          ...(action?.payload?.skillId
            ? {
                [action?.payload?.skillId]: action?.payload?.data,
              }
            : {}),
        },
        status: {
          get_faq: {
            ...initialStatus,
            success: !action?.payload?.skillId
              ? true
              : state?.status?.get_faq?.success,
          },
          get_faq_by_skill: {
            ...initialStatus,
            success: action?.payload?.skillId
              ? true
              : state?.status?.get_faq_by_skill?.success,
          },
        },
      }
    }
    case 'UPDATE_FAQ':
      return {
        ...state,
        status: {
          update_faq: {
            ...initialStatus,
            loading: true,
            data: { ...action.payload },
          },
        },
      }
    case 'UPDATED_FAQ':
      return {
        ...state,
        status: {
          update_faq: {
            ...initialStatus,
            success: true,
            message: action?.payload?.message,
          },
        },
      }

    case 'SET_FILE':
      return {
        ...state,
        file: action?.payload,
      }

    case 'SET_FAQ_EXPANDED':
      return {
        ...state,
        expanded: {
          ...state?.expanded,
          [action?.payload?.id]: {
            ...state?.expanded?.[action?.payload?.id],
            [action?.payload?.category]: action?.payload?.expanded,
          },
        },
      }

    case 'SET_KEYWORD_SEARCH':
      return {
        ...state,
        keyword: {
          ...state?.keyword,
          [action?.payload?.id]: action?.payload?.keyword,
        },
      }

    case 'SET_TAB_OPEN':
      return {
        ...state,
        tabOpen: {
          ...state?.tabOpen,
          [action?.payload?.id]: action?.payload?.tabOpen,
        },
      }

    default:
      return state
  }
}

export default faqReducer
